import { IntlShape } from 'react-intl';
import changeEmailMessages from '../../../../messages/change-email.messages';
import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import { ErrorMessages, FormattedErrorMessages } from '../../../../model/error';
import { isEmailValid } from '../../../../utils/validators';
import {
  ChangeEmailState,
  ExpiredDocumentError,
  InsertEmailChangeEmailError,
  VerificationEmailChangeEmailError,
} from './change-email-type';

export const verifyInsertEmailChangeEmailFields = (
  state: ChangeEmailState
): InsertEmailChangeEmailError | undefined => {
  const { email, confirmNewEmail } = state;

  if (email !== confirmNewEmail) {
    return 'EMAILS_NOT_MATCHING';
  }
  if (!isEmailValid(email)) {
    return 'INVALID_EMAIL_FORMAT';
  }
  return undefined;
};

export const messagesForInsertEmailChangeEmailError = (
  error: InsertEmailChangeEmailError
): ErrorMessages => {
  switch (error) {
    case 'INVALID_EMAIL_FORMAT':
      return {
        title: changeEmailMessages.errorInvalidEmailFormat,
      };
    case 'EMAILS_NOT_MATCHING':
      return {
        title: changeEmailMessages.errorEmailsNotMatching,
      };
    case 'EMAIL_NON_UTILIZZABILE':
      return {
        title: changeEmailMessages.errorEmailNotUsable,
      };
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};

export const messagesForExpiredDocumentError = (
  error: ExpiredDocumentError
): ErrorMessages => {
  switch (error) {
    case 'DOCUMENTO_SCADUTO':
      return {
        title: changeEmailMessages.errorExpiredDocument,
      };
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};

export const messagesForVerificationEmailChangeEmailError = (
  error: VerificationEmailChangeEmailError,
  intl?: IntlShape
): FormattedErrorMessages => {
  const { formatMessage } = intl;
  switch (error.type) {
    case 'CODICE_DI_VERIFICA_SBAGLIATO':
      return {
        title: formatMessage(changeEmailMessages.errorWrongCode, {
          attemptsEmail: error.attemptsEmail,
          attemptsPhoneNumber: error.attemptsPhoneNumber,
        }),
      };
    case 'CODICE_DI_VERIFICA_EMAIL_SBAGLIATO':
      return {
        title: formatMessage(changeEmailMessages.wrongOtpCodeEmailError, {
          attemptsEmail: error.attemptsEmail,
          attemptsPhoneNumber: error.attemptsPhoneNumber,
        }),
      };
    case 'CODICE_DI_VERIFICA_CELLULARE_SBAGLIATO':
      return {
        title: formatMessage(changeEmailMessages.wrongOtpCodePhoneError, {
          attemptsEmail: error.attemptsEmail,
          attemptsPhoneNumber: error.attemptsPhoneNumber,
        }),
      };
    case 'GENERIC_ERROR':
    default:
      return {
        title: formatMessage(commonErrorMessages.errorTitleDefault),
        description: formatMessage(commonErrorMessages.errorDescriptionDefault),
      };
  }
};
